import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaUsers, FaUserFriends, FaBookOpen, FaRobot } from 'react-icons/fa';
import './feed.shared.css';
import { useAuth } from '../../context/AuthContext';

const FeedSidebarMenu = ({ onAction }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();

    const isInvestigator = user?.roles?.some(r => {
        const roleName = typeof r === 'string' ? r : r.name;
        return ['INVESTIGATOR', 'INSTITUTION', 'HEALTH_PROFESSIONAL'].includes(roleName);
    });

    const networkPath = isInvestigator ? '/researcher-network' : '/patient-network';

    const menuItems = [
        {
            id: 'network',
            label: 'Mi Red',
            icon: <FaUserFriends />,
            path: networkPath,
        },
        {
            id: 'groups',
            label: 'Grupos',
            icon: <FaUsers />,
            path: isInvestigator ? '/researcher-groups' : '/groups',
        },
        {
            id: 'resources',
            label: 'Recursos',
            icon: <FaBookOpen />,
            path: '/resources',
        },
        {
            id: 'ai-search',
            label: 'Buscar información con IA',
            icon: <FaRobot />,
            path: '/patient-ai',
        }
    ];

    const handleClick = (item) => {
        if (item.action && onAction) {
            onAction(item.action);
        } else {
            navigate(item.path);
        }
    };

    return (
        <div className="feed-sidebar-menu">
            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        className={`sidebar-nav-item ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={() => handleClick(item)}
                    >
                        <span className="nav-icon">{item.icon}</span>
                        <span className="nav-label">{item.label}</span>
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default FeedSidebarMenu;
